export default __webpack_public_path__ + "static/media/outroeu.14818f4c.mp3";